import React from 'react';
import { isMeetingCreatedByUser } from '../../../../../data/filters/meetings/isMeetingCreatedByUser';
import { useMyUserId } from '../../../../../data/hooks/sessionHooks';
import meetingState from '../../../../../data/constants/meetingState';
import MessageBubble from '../MeetingInvite/MessageBubble';
import ReplyIcon from './reply.svg';

function RejectionReason(props) {
    const { className = '', invite, meeting } = props,
        selfUserId = useMyUserId(),
        { reason_text: reason } = invite;

    if (!isMeetingCreatedByUser(selfUserId, meeting)) return null;
    if (!reason) return null;

    return <MessageBubble className={className} icon={<ReplyIcon />} user={invite.user}>{reason}</MessageBubble>;
}

export default RejectionReason;
